var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('progress',{staticClass:"ProjectProgressionbar progress",class:[{'darkMode':_vm.themeToDisplay=='dark'},_vm.colorByPercent(_vm.project)],attrs:{"max":"100"},domProps:{"value":_vm.calculateProjectPercent(_vm.project)}})}
var staticRenderFns = []

export { render, staticRenderFns }